import { apiGateway } from '../api';

async function getGrauParentesco(codigoPlano, numeroContrato, dataUltimaVigencia) {
    try {
        const params = new URLSearchParams();
        params.append('numContrato', numeroContrato);
        params.append('dtInicioVigencia', dataUltimaVigencia);

        const response = await apiGateway.get(`/plano/${codigoPlano}/dependencias`, { params });
        return response.data;
    } catch (error) {
        return error;
    }
}

export { getGrauParentesco };
